import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { store } from '../../../redux/store/configureStore';

const Breadcrumbs = ({ currentRoute }) => {
  const route = currentRoute;
  const activeRoute = route.indexOf('order-details') > -1;
  if (activeRoute) {
    return (
      <div className="breadcrumb-container">
        <button className="item"><a className="item" href="https://www.bestwaywholesale.co.uk">Bestway &gt;&nbsp;</a></button>
        <button
          onClick={() => store.dispatch(push({ pathname: '/' }))}
          className="item"
        >
        Orders &gt;&nbsp;
        </button>
        <button className="activeItem">
        Order Tracking
        </button>
      </div>
    );
  }
  return (
    <div className="breadcrumb-container">
      <button className="item"><a className="item" href="https://www.bestwaywholesale.co.uk">Bestway  &gt;&nbsp;</a></button>
      <button className="item activeItem">Orders</button>
    </div>
  );
};

Breadcrumbs.propTypes = {
  currentRoute: PropTypes.string.isRequired,
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// src/components/atoms/Breadcrumbs/index.jsx